<!-- <div class="bar-container">
    @for (bar of barHeights; track $index) {
        <div class="bar" [style.height.%]="bar">{{bar}}</div>
    }
</div> -->

<div class="diagonal-bars">
    @for (col of bars; track $index) {
        <div class="d-column">
            @for (row of [0, 1, 2]; track $index) {
                <div
                    class="d-row"
                    [class.active]="$index >= 3 - col.visibleBars"
                ></div>
            }
        </div>
    }
    
    <div class="static-flag">
        <!-- <img src="assets/images/static-flag.svg" alt=""> -->
    </div>
</div>

<!-- <div class="diagonal-bars">
    <div class="d-column">
        <div class="d-row"></div>
        <div class="d-row"></div>
        <div class="d-row"></div>
    </div>
    <div class="d-column">
        <div class="d-row"></div>
        <div class="d-row"></div>
        <div class="d-row"></div>
    </div>
    <div class="d-column">
        <div class="d-row"></div>
        <div class="d-row"></div>
        <div class="d-row"></div>
    </div>
</div> -->

